import { render, staticRenderFns } from "./IvanGroupProjectList.vue?vue&type=template&id=4e0c3598&scoped=true"
import script from "./IvanGroupProjectList.vue?vue&type=script&lang=js"
export * from "./IvanGroupProjectList.vue?vue&type=script&lang=js"
import style0 from "./IvanGroupProjectList.vue?vue&type=style&index=0&id=4e0c3598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0c3598",
  null
  
)

export default component.exports